<template>
  <div v-if="_.get(itemData, 'primary.0')" class="mt-34">
    <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
      <div
        class="text fadeUp"
        v-html="_.get(itemData, 'primary.0.content.tabs[0].content')"
        :class="animate ? 'animate' : ''"
      ></div>
    </intersect>

    <LayoutImages
      v-if="_.get(itemData, 'primary[0]')"
      :imageData="_.get(itemData, 'primary[0]')"
    />
    <intersect @enter="animate2 = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
      <div
        class="mt-34 fadeUp"
        v-html="_.get(itemData, 'primary.0.content.tabs[1].content')"
        :class="animate2 ? 'animate' : ''"
      ></div>
    </intersect>

    <!-- <SimpleList /> -->

    <template v-if="_.get(itemData, 'primary.0.smarttable')">
      <ScrollList
        v-for="(table, index) in _.get(itemData, 'primary.0.smarttable')"
        v-if="_.get(table, 'data')"
        :key="index"
        :itemData="table"
      />
    </template>

    <DropdownsList
      :itemData="_.get(itemData, 'primary[0].required_documents')"
      v-if="_.get(itemData, 'primary[0].required_documents.rowTitles.0')"
    />
  </div>
</template>
<script>
import LayoutImages from "@/components/LayoutImages";
import SimpleList from "@/components/SimpleList";
import DropdownsList from "@/components/DropdownsList";
import ScrollList from "@/components/ScrollList";
import Intersect from "vue-intersect";

export default {
  props: ["itemData"],
  components: {
    LayoutImages,
    SimpleList,
    DropdownsList,
    ScrollList,
    Intersect,
  },
  data() {
    return {
      animate: false,
      animate2: false,
    };
  },
};
</script>

<style>
@media screen and (max-width: 767px) {
  .mt-34 {
    margin-top: 0;
  }
}

</style>